import { render } from "./PresentInfo.vue?vue&type=template&id=3334642a&scoped=true"
import script from "./PresentInfo.vue?vue&type=script&lang=js"
export * from "./PresentInfo.vue?vue&type=script&lang=js"

import "./PresentInfo.vue?vue&type=style&index=0&id=3334642a&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3334642a"]])

export default __exports__